<template>
  <div class="def-scrollbar">
    <slot />
  </div>
</template>

<!--<script lang="ts" setup></script>-->

<style lang="scss" scoped>
.def-scrollbar {
  overflow-y: auto;
  overscroll-behavior: contain;
  &::-webkit-scrollbar {
    width: 20px;
  }
  &::-webkit-scrollbar-track {
    background-color: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background-color: #aaa;
    border-radius: 20px;
    border: 6px solid transparent;
    background-clip: content-box;
    transition: 0.2s linear background-color;
    &:hover {
      background-color: #999;
    }
  }
}
</style>
